import { render, staticRenderFns } from "./DocPublicacoesNova.vue?vue&type=template&id=77d070bc&scoped=true&lang=pug&"
import script from "./DocPublicacoesNova.vue?vue&type=script&lang=js&"
export * from "./DocPublicacoesNova.vue?vue&type=script&lang=js&"
import style0 from "./DocPublicacoesNova.vue?vue&type=style&index=0&id=77d070bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d070bc",
  null
  
)

export default component.exports